import React from 'react';
import {PageNavigation, RenderOnlyFor} from '@ignitesales/neuro-application';
import LandingPage from './pages/LandingPage.jsx';
import SurveyPage from './pages/SurveyPage.jsx';
import SummaryPage from './pages/SummaryPage.jsx';
import {scrollToTop, DialogueThemeContainer, LoadingDataIcon, DialoguePageContainer} from "../../../../../../shared/js";
import TexturedBar from "./TexturedBar";
import BasicHeader from "../../../../../../shared/js/core-components/BasicHeader";

const App = () => {
    return <DialogueThemeContainer>
        <RenderOnlyFor forSurveyPage forLandingPage>
          <BasicHeader />
        </RenderOnlyFor>
        <DialoguePageContainer
            LandingPage={LandingPage}
            SurveyPage={SurveyPage}
            SummaryPage={SummaryPage}
            DetailsPage={SummaryPage}
        />
        <RenderOnlyFor forSurveyPage={true}>
            <TexturedBar />
            <div className="navigationBar">
                <PageNavigation onNextPageClicked={ scrollToTop } onPreviousPageClicked={ scrollToTop } />
                <LoadingDataIcon />
            </div>
        </RenderOnlyFor>
    </DialogueThemeContainer>;
};

export default App;
